import React, { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import {
  Truck,
  LogOut,
  Home,
  History,
  Phone,
  User,
} from "lucide-react";

export default function DomiciliarioLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  // Número de central para contacto
  const CENTRAL_PHONE = "573196536874";

  const handleContactCentral = () => {
    const message = encodeURIComponent("Hola, soy " + user?.nombre + " y necesito asistencia con mi ruta.");
    window.open(`https://wa.me/${CENTRAL_PHONE}?text=${message}`, "_blank");
  };

  return (
    <div className="min-h-screen bg-[#FBF5E8] flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-[#E5D4B3] px-4 py-3 sticky top-0 z-40">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#C8902A] rounded-full flex items-center justify-center">
              <Truck className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="font-['Playfair_Display'] text-lg text-[#4A2C0A] font-bold leading-tight">
                Entregas
              </h1>
              <p className="text-xs text-[#4A2C0A]/60">{user?.nombre}</p>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={handleContactCentral}
              className="gap-1 border-green-500 text-green-600 hover:bg-green-50"
              data-testid="contact-central-btn"
            >
              <Phone className="w-4 h-4" />
              <span className="hidden sm:inline">Central</span>
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLogout}
              className="text-[#4A2C0A]/60"
              data-testid="logout-btn"
            >
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 overflow-auto pb-20">
        <Outlet />
      </main>

      {/* Bottom Navigation - Mobile First */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#E5D4B3] px-4 py-2 z-40">
        <div className="flex items-center justify-around max-w-md mx-auto">
          <NavLink
            to="/delivery/dashboard"
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-4 py-2 rounded-xl transition-colors ${
                isActive
                  ? "text-[#C8902A] bg-[#C8902A]/10"
                  : "text-[#4A2C0A]/60 hover:text-[#4A2C0A]"
              }`
            }
            data-testid="nav-dashboard"
          >
            <Home className="w-5 h-5" />
            <span className="text-xs font-medium">Hoy</span>
          </NavLink>
          
          <NavLink
            to="/delivery/historial"
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-4 py-2 rounded-xl transition-colors ${
                isActive
                  ? "text-[#C8902A] bg-[#C8902A]/10"
                  : "text-[#4A2C0A]/60 hover:text-[#4A2C0A]"
              }`
            }
            data-testid="nav-historial"
          >
            <History className="w-5 h-5" />
            <span className="text-xs font-medium">Historial</span>
          </NavLink>
          
          <NavLink
            to="/delivery/perfil"
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-4 py-2 rounded-xl transition-colors ${
                isActive
                  ? "text-[#C8902A] bg-[#C8902A]/10"
                  : "text-[#4A2C0A]/60 hover:text-[#4A2C0A]"
              }`
            }
            data-testid="nav-perfil"
          >
            <User className="w-5 h-5" />
            <span className="text-xs font-medium">Perfil</span>
          </NavLink>
        </div>
      </nav>
    </div>
  );
}
